import { useLocation } from 'react-router'
import { z } from 'zod'
import { VariableWithResult } from '~/packages/general/variable/variables.typing'
import { BaseActionDefinitionEnhanced } from '~/prix'
import useAction from '~/prix/react/hooks/action'
import useAPI from '~/prix/react/hooks/api'

export function useVariableFetchList<
  InputType extends z.ZodType<any, any> = z.ZodType<any, any>,
  OutputType extends z.ZodType<any, any> = z.ZodType<any, any>,
>(viewListDefinition: BaseActionDefinitionEnhanced<InputType, OutputType>) {
  const { context, isLoading: isLoadingAPI } = useAPI()
  const location = useLocation()

  const variablesResult = useAction(viewListDefinition, {}, [], {
    autoLoad: Boolean(context.user) && !isLoadingAPI,
    staleWhileRevalidate: true,
  })

  const currentToolSelected = useAction(
    viewListDefinition,
    {
      path: location.pathname,
    },
    [],
    {
      autoLoad: Boolean(context.user) && !isLoadingAPI,
      staleWhileRevalidate: true,
    },
  )

  const variables: Array<VariableWithResult> = variablesResult.result?.items ?? []
  const currentTool =
    location.state?.currentBaseLayer.variable ?? currentToolSelected.result?.items[0]
  const variablesAreLoading = variablesResult.isLoading || currentToolSelected.isLoading
  return { variables, currentTool, variablesAreLoading }
}
